import React from 'react';
import i18n from '../../i18n/i18n.js';
import { Link } from "react-router-dom";
import { Utils } from '../../Utils.js';
import NewsletterSubscribe from '../../components/NewsletterSubscribe/NewsletterSubscribe';
import LoyaltyClub from '../../components/LoyaltyClub/LoyaltyClub';
import HeaderBanner from '../../components/HeaderBanner/HeaderBanner';
import Banner from "../../components/Banner/Banner.js";
import ProductListItem from '../../components/ProductListItem/ProductListItem.js';
import { Swiper, SwiperSlide  } from 'swiper/react';
import ReactDOM from 'react-dom/client';
import Barcode  from 'react-barcode';

// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

import './Home.css'; 

class Home extends React.Component {

  state = {
    banners:{},
    products:{},
    loaded:0
  }

  componentDidMount()
  {
    Utils.get_server_data('', { APICACHE: true }).then((resp) => {
        this.setState({products:resp.products});
        this.setState({banners:resp.banners},()=>this.setState({loaded:1}));
    });
  }

  constructor(props) {
      super(props);
  }

  render_products_slider(options) {
    return <div className="product_list_inner"><div className={options.class}>
        <div className='title'>{options.title}</div>
        <div className='slider-outer'>
            <div className='slider-inner'>
            {options.products.map(product => <ProductListItem key={`${product.id}`} product={product} />)}
            </div>
        </div>
    </div></div>
  }

  render() {
    const home_card_slide = parseInt(window.AppRef.current.state.home_card_slide) == 1;
    
    const ugyfelkartya = window.AppRef.current.get_ugyfelkartya();

    return <div className={`container page_home`}>
          <div className="content">

            {ugyfelkartya?.ugyfelkartya_number && home_card_slide ? <HeaderBanner text={i18n.t("customerCard")} >
            <div className="customer_card_box_wrapper">
              <div className="customer_card_box" onClick={() => { window.modals['ProfileMenuRef'].current.show(); window.modals['RoyaltyCardRef'].current.show(); }}>
                <label>Dorko Royalty Club</label>
                <Barcode value={ugyfelkartya.ugyfelkartya_number} />
              </div>
            </div>
            </HeaderBanner> : ''}

            {ugyfelkartya?.ugyfelkartya_number && !home_card_slide ? 
            <div className="customer_card_box_wrapper">
              <div className="customer_card_box" onClick={() => { window.modals['ProfileMenuRef'].current.show(); window.modals['RoyaltyCardRef'].current.show(); }}>
                <label>Dorko Royalty Club</label>
                <Barcode value={ugyfelkartya.ugyfelkartya_number} />
              </div>  
            </div> 
             : ''}

            {this.state.loaded==0 ? <div className='placeholder_rectangle home_banner'></div> : '' }

            {this.state.banners?.app_home_hero?.[0] ? 

              <Swiper 
                className='home_hero_slide'
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: true,
                }}
                pagination={{
                  clickable: true,
                }}
                //navigation={true}
                modules={[Autoplay, Pagination, Navigation]}>
                  {this.state.banners.app_home_hero[0].map((banner,index)=>{
                    return <SwiperSlide key={banner.id}>
                      <Banner type={(banner.banner_type) ? banner.banner_type : ''} text={banner.alt} url={banner.link} image={banner.banner} />
                    </SwiperSlide>
                  })}
              </Swiper>

            : ''}

            {(this.state.products?.most_popular?.products) ? this.render_products_slider({
              class: 'products_slider best_products_slider',
              title: i18n.t('homeBestTitle'),
              products: this.state.products?.most_popular?.products
            }) : ''}


            {this.state.banners?.app_home_category_banner?.[0] 
            ? 
            <>
              {this.state.banners.app_home_category_banner[0].map((banner,index)=>{
                    return <Banner key={banner.id} type={(banner.banner_type) ? banner.banner_type : ''} text={banner.alt} url={banner.link} image={banner.banner} />
                  })}
              </>
            : ''}

            {this.state.banners?.homepage_recommend_banner?.[0] ?
              <Swiper 
                className='home_recommended_slide'
                
                pagination={{
                  clickable: true,
                }}

                //navigation={true}
                modules={[Pagination, Navigation]}>
                  {this.state.banners.homepage_recommend_banner[0].map((banner,index)=>{
                    return <SwiperSlide key={banner.id}>
                      <Banner type={(banner.banner_type) ? banner.banner_type : ''} text={banner.alt} url={banner.link} image={banner.banner_mobile} />
                    </SwiperSlide>
                  })}
              </Swiper>
            : ''}
            
            {/*
<Banner url="products/ferfi" image="assets/images/demo/home/ferfi.png">
              <span className="banner-button"><button className='button'>Férfi</button></span>
            </Banner>

            <Banner url="products/noi" image="assets/images/demo/home/noi.png">
              <span className="banner-button"><button className='button'>Női</button></span>
            </Banner>

            <Banner url="products/gyerek-cipo" image="assets/images/demo/home/gyerek.png">
              <span className="banner-button"><button className='button'>Gyerek</button></span>
            </Banner>
             */}
            

            <NewsletterSubscribe />
            <LoyaltyClub />

        </div>
      </div>;
    }
}

export default Home;